// BedTypesPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const BedTypesPage = () => <ComingSoon title="Bed types" description="Define the bed types available in your rooms." />;

export default BedTypesPage;
